import {
  Application,
  CreateApplication,
  CreateTemplate,
  Template,
  UpdateTemplate
} from '@thro-types/notification';

import { AxiosError, AxiosRequestConfig } from 'axios';
import { Gateway } from 'index';

export const getApplications = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<Application[]>('/notification/v1/applications', config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const createApplication = async (data: CreateApplication, config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.post<Application>('/notification/v1/applications', data, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getTemplates = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<Template[]>('/notification/v1/templates/bulk', config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getTemplate = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<Template>('/notification/v1/templates', config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getBulkTemplates = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<Template[]>('/notification/v1/templates/bulk', config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const createTemplate = async (data: CreateTemplate, config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.post<Template>('/notification/v1/templates', data, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const updateTemplate = async (
  id: number,
  data: UpdateTemplate,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.put<Template>(`/notification/v1/templates/${id}`, data, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};
